export default __webpack_public_path__ + "static/media/support-person.fb30d766.png";